import * as React from 'react'

import { useSavedJobs } from './SavedJobsProvider'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuCheckboxItem,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from '../../../lib/ui/dropdown-menu'
import { useTranslation } from '../../../hooks/useTranslation'
import { ChevronDown } from 'lucide-react'
import { Button } from '../../../lib/ui/button'

export function SortByDropdown() {
  const {
    sortBy: {
      pinFollowupJobs,
      setPinFollowupJobs,
      sortByValue,
      setSortByValue,
    },
  } = useSavedJobs()
  const { t } = useTranslation('sort_by')

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="default"
          className="flex flex-row gap-2 rounded-full border border-[#B9B9B9] bg-white pl-3 pr-2 text-xs text-black hover:bg-white focus:bg-accent data-[status=applied]:bg-[#FFB74D] data-[status=archive]:bg-white data-[status=closed]:bg-[#D8D8D8] data-[status=interview]:bg-[#FFE082] data-[status=offer]:bg-[#65E083] data-[status=saved]:bg-[#5CA9E6] sm:px-4 sm:text-base"
          data-status={sortByValue}
        >
          {t(sortByValue)}
          <ChevronDown className="h-3 w-3 sm:h-4 sm:w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuCheckboxItem
          checked={pinFollowupJobs}
          onCheckedChange={setPinFollowupJobs}
          className="text-base"
        >
          {t('pin_followup_jobs')}
        </DropdownMenuCheckboxItem>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup
          value={sortByValue}
          onValueChange={setSortByValue}
        >
          <DropdownMenuRadioItem value="created_at" className="text-base">
            {t('created_at')}
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="updated_at" className="text-base">
            {t('updated_at')}
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="followup_on" className="text-base">
            {t('followup_on')}
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
